import React, {useState, useEffect} from 'react';
import {redirect} from "../../utils/commonFunc";
import MainController from "../MainController";
import useDisableScroll from "../../../customHook/useDisableScroll";
function MainView(props) {
    const {
        products, searchText, setSearchText, setProducts,fetchProducts
    } = MainController();

    const [isSearching, setIsSearching] = useState(false);
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const updateHeight = () => {
            const headerElement = document.querySelector('.header-section');
            if (headerElement) {
                setHeaderHeight(headerElement.offsetHeight);
            }
        };

        updateHeight();

        const resizeObserver = new ResizeObserver(updateHeight);
        const headerElement = document.querySelector('.header-section');
        if (headerElement) {
            resizeObserver.observe(headerElement);
        }

        return () => {
            if (headerElement) {
                resizeObserver.unobserve(headerElement);
            }
        };
    }, []);
    useEffect(() => {
        const parentContainer = document.querySelector('#container-search-mobile');
        const container = document.querySelector('.container-search-mobile-box');

        if (parentContainer && container) {
            const isContainerFixed = window.getComputedStyle(parentContainer).position === 'fixed';
            if (isSearching && !isContainerFixed) {
                container.style.height = '100vh';
                container.style.transform = `translateY(-${headerHeight}px)`;
            } else if (isSearching && isContainerFixed) {
                parentContainer.style.height = '100vh';
                container.style.height = '100%';
            } else {
                container.style.height = '';
                container.style.transform = '';
                parentContainer.style.height = '';
            }
        }
    }, [isSearching, headerHeight]);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 480) {
                setIsSearching(false);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize(); 

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useDisableScroll(isSearching);
    
    return (<div className="container-search-mobile-box">
        <div className="search-form-mobile">
            {isSearching && <div className="cancel-search-mobile" onClick={() => {
                setIsSearching(false)
            }}>
                <i className="fa-solid fa-arrow-left"></i>
            </div>}
            <div className="search-form-mobile-box">

                <input className="input-search-mobile" onFocus={() => {
                    fetchProducts()
                    setIsSearching(true)
                }} placeholder="Tìm kiếm sản phẩm..." type="search" name="searchtext"
                       defaultValue={searchText} onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        if(searchText && searchText?.trim()!=="") redirect("", searchText)
                        else event.target.blur()
                        setIsSearching(false)
                    }
                }} onChange={(e) => setSearchText(e.target.value)} style={{backgroundColor: 'white'}}/>
                <button className="button-search-mobile" title="Tìm kiếm" onClick={() => {
                    if(searchText && searchText?.trim()!=="") redirect("", searchText);
                    else document.querySelector('.input-search-mobile').blur();
                    setIsSearching(false)
                }}>
                    <i className="fa-solid fa-magnifying-glass"></i>
                </button>
            </div>
        </div>

        {isSearching && products?.length > 0 && <div className="search-suggestions">
            <h5 className="search-suggestions-title">Sản phẩm gợi ý</h5>
            <ul className="search-suggestions-list">
                {products?.map(product => (<li key={product?.id} style={{cursor: 'pointer'}} onClick={() => {
                    redirect(product?.name);
                    setIsSearching(false)
                }}>
                    <i className="fa-solid fa-magnifying-glass search-suggestions-icon"></i> {product?.name}
                </li>))}
            </ul>
        </div>}
    </div>)
}

export default MainView;